module.exports = __webpack_public_path__ + "static/media/dot-blue.313e0dc1.svg";